import { Box } from '@mui/material';
import React from 'react';
import { SelectableCard } from './SelectableCard';
import { getCardColors } from './cardColors';
import { CardActions, CardIconCheckbox } from './components';
export const SelectableIconCard = (props) => {
    return (React.createElement(Box, { sx: { position: 'relative' } },
        React.createElement(SelectableCard, Object.assign({}, props, { sx: { display: 'grid', gridTemplateColumns: 'auto 1fr auto' } }),
            React.createElement(Box, { sx: { width: 80, minHeight: 80, backgroundColor: getCardColors()[props.color] } }),
            React.createElement(Box, { sx: { alignSelf: 'center', overflow: 'hidden' } }, props.children),
            React.createElement(CardActions, Object.assign({}, props))),
        React.createElement(Box, { sx: { position: 'absolute', top: 'calc(50% - 40px)', left: 1 } },
            React.createElement(CardIconCheckbox, Object.assign({}, props)))));
};
